import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { AuthShell, Field, inputClass } from "@/pages/auth/authShared";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); } catch {}
    setSent(true); setLoading(false);
  };

  return (
    <AuthShell title="Reset your password" subtitle="We'll email you a secure link"
      footer={<Link to="/login" className="font-semibold text-[#B04B26] hover:underline">← Back to log in</Link>}>
      {sent ? (
        <div className="text-center" data-testid="forgot-sent">
          <p className="text-[#2D1E18]">If <span className="font-semibold">{email}</span> is registered, a reset link is on its way. Please check your inbox (and spam folder).</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <Field label="Email"><input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputClass} data-testid="forgot-email" /></Field>
          <button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full rounded-xl bg-[#C85A32] px-4 py-3 font-bold text-white hover:bg-[#B04B26] disabled:opacity-60">{loading ? "Sending…" : "Send reset link"}</button>
        </form>
      )}
    </AuthShell>
  );
}
